export default "__VITE_ASSET__DzaA7s_T__"